<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="550px"
    :close-on-click-modal="false"
  >
    <el-input
      type="textarea"
      :autosize="{ minRows: 3, maxRows: 16 }"
      placeholder="请输入班级备注"
      v-model="remarkInfo"
      show-word-limit
      :maxlength="1000"
    />
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      remarkInfo: "",
    };
  },
  mounted() {
    if (this.dialogInfo.initRemark) {
      this.remarkInfo = this.dialogInfo.initRemark;
    }
  },
  methods: {
    closeDia() {
      this.$emit("closeRemark", false);
    },
    sureSubmit() {

      this.$emit("closeRemark", true, this.remarkInfo);
    },
  },
};
</script>

<style>
</style>
